import { Outlet } from "react-router-dom";

import {
  BubbleChart,
  Person,
  QueryStats,
  RocketLaunch,
  UploadFile,
} from "@mui/icons-material";

import { AppContainer, AuthContainer } from "@/components/containers";
import { DialogRoot } from "@/components/molecules";
import {
  ActivationProvider,
  AudienceProvider,
  SnackbarProvider,
  DialogProvider,
  ViewModeProvider,
} from "@/context";
import { Navigation } from "@/types";

const NAVIGATION: Navigation = [
  {
    segment: "audience",
    title: "Audiences",
    icon: <Person />,
    pattern: "audience/:id?/:segment?",
  },
  {
    segment: "upload",
    title: "Upload",
    icon: <UploadFile />,
    pattern: "upload/:id?/:segment?",
  },
  {
    segment: "mindset",
    title: "Mindsets",
    icon: <BubbleChart />,
    pattern: "mindset/:id?/:segment?",
  },
  {
    segment: "activation",
    title: "Activation",
    icon: <RocketLaunch />,
    pattern: "activation/:id?/:segment?",
  },
  {
    segment: "measurement",
    title: "Measurement",
    icon: <QueryStats />,
  },
  // {
  //   segment: 'explore',
  //   title: 'Explore',
  //   icon: <Explore />,
  // },
];

function App() {
  return (
    <AuthContainer>
      <SnackbarProvider>
        <DialogProvider>
          <ViewModeProvider>
            <AudienceProvider>
              <ActivationProvider>
                <AppContainer navigation={NAVIGATION}>
                  <Outlet />
                  <DialogRoot />
                </AppContainer>
              </ActivationProvider>
            </AudienceProvider>
          </ViewModeProvider>
        </DialogProvider>
      </SnackbarProvider>
    </AuthContainer>
  );
}

export default App;
